type ProjectTypes = 'foundation' | 'project' | 'Project Group';
type OrderBy =
  | 'createddate'
  | 'name'
  | 'status'
  | 'renewalType'
  | 'projectSector'
  | 'executiveDirector'
  | 'programManager';

export interface SearchFoundationsInput {
  pagesize?: number;
  orderBy?: OrderBy;
  limit?: number;
  sortDir?: 'asc' | 'desc';
  name?: string[];
  description?: string;
  status?: string[];
  projectType?: ProjectTypes[];
  projectSector?: string[];
  repository?: string[];
  slug?: string[];
  type?: string[];
  id?: string[];
  excludeSubproject?: boolean;
  enabledService?: string[];
}
